var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "employee-agreements" },
    [
      !_vm.inited
        ? _c("Loader", {
            staticClass: "mt-4",
            attrs: {
              active: !_vm.inited,
              label: "Данные загружаются",
              height: 400,
            },
          })
        : [
            _vm.empty
              ? _c("div", { staticClass: "employee-agreements__empty" }, [
                  _vm._v("Договоров для печати пока нет"),
                ])
              : _c(
                  "div",
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "employee-agreements__filters agreements-filters",
                      },
                      [
                        _vm.filtersOpen
                          ? _c("c-button2", {
                              staticClass: "agreements-filters__toggler",
                              attrs: { label: "Скрыть фильтры" },
                              on: {
                                click: function ($event) {
                                  _vm.filtersOpen = false
                                },
                              },
                            })
                          : _vm._e(),
                        _c("transition", { attrs: { name: "slide" } }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.filtersOpen,
                                  expression: "filtersOpen",
                                },
                              ],
                              staticClass: "agreements-filters__slide",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "agreements-filters__wrapper" },
                                [
                                  _c("c-input", {
                                    ref: "periodPicker",
                                    staticClass:
                                      "agreements-filters__item agreements-filters__period",
                                    attrs: {
                                      label: "Период договора",
                                      placeholder: "00.00.0000 - 00.00.0000",
                                      type: "period-without-fixed-intervals",
                                      icon: "calendar",
                                      clearable: true,
                                      "icon-right": true,
                                    },
                                    model: {
                                      value: _vm.filters.period,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "period", $$v)
                                      },
                                      expression: "filters.period",
                                    },
                                  }),
                                  _c("c-input", {
                                    staticClass:
                                      "agreements-filters__item agreements-filters__company",
                                    attrs: {
                                      type: "select",
                                      label: "Юридическое лицо",
                                      searchable: true,
                                      placeholder: "Любое",
                                      clearable: true,
                                      items: _vm.collections.companies,
                                    },
                                    model: {
                                      value: _vm.filters.company,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "company", $$v)
                                      },
                                      expression: "filters.company",
                                    },
                                  }),
                                  _c("c-select", {
                                    staticClass:
                                      "agreements-filters__item agreements-filters__type",
                                    attrs: {
                                      type: "select",
                                      label: "Тип договора",
                                      searchable: true,
                                      multiple: true,
                                      items: _vm.collections.agreementTypes,
                                      groups: _vm.collections.agreementGroups,
                                      placeholder: "Все",
                                    },
                                    model: {
                                      value: _vm.filters.types,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "types", $$v)
                                      },
                                      expression: "filters.types",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "agreements-filters__actions" },
                                [
                                  _c("c-button", {
                                    staticClass: "agreements-filters__reset",
                                    attrs: { size: "large", label: "Сбросить" },
                                    on: { click: _vm.resetFilters },
                                  }),
                                  _c("c-button", {
                                    staticClass: "agreements-filters__apply",
                                    attrs: {
                                      label: "Применить",
                                      color: "blue",
                                      size: "large",
                                    },
                                    on: { click: _vm.applyFilters },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                        _vm.filtersOpen
                          ? _c("c-button2", {
                              staticClass: "agreements-filters__toggler",
                              attrs: { label: "Скрыть фильтры" },
                              on: {
                                click: function ($event) {
                                  _vm.filtersOpen = false
                                },
                              },
                            })
                          : _vm._e(),
                        !_vm.filtersOpen
                          ? _c("c-button2", {
                              staticClass: "agreements-filters__toggler",
                              attrs: { label: "Показать фильтры" },
                              on: {
                                click: function ($event) {
                                  _vm.filtersOpen = true
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm.loading
                      ? _c("Loader", {
                          attrs: {
                            active: _vm.loading,
                            label: "Данные загружаются",
                            height: 400,
                          },
                        })
                      : _vm._e(),
                    !_vm.loading
                      ? _c("scrolled-table", { staticClass: "lg" }, [
                          _c(
                            "table",
                            { staticClass: "h-table agreements-table" },
                            [
                              _c("thead", [
                                _c("tr", [
                                  _c("th", { attrs: { width: "500" } }, [
                                    _c(
                                      "div",
                                      { staticClass: "h-table__header" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "h-table__col-title",
                                            class: {
                                              active:
                                                _vm.sortBy === "company_name",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.sort("company_name")
                                              },
                                            },
                                          },
                                          [_vm._v(" Юридическое лицо ")]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("th", { attrs: { width: "1400" } }, [
                                    _c(
                                      "div",
                                      { staticClass: "h-table__header" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "h-table__col-title",
                                            class: {
                                              active:
                                                _vm.sortBy === "agreement_name",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.sort(
                                                  "agreement_name"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(" Договор ")]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("th", {
                                    staticClass: "agreements-table__actions",
                                  }),
                                ]),
                              ]),
                              _vm._l(_vm.positions, function (position) {
                                return [
                                  _vm.positions.length > 1
                                    ? _c(
                                        "tr",
                                        {
                                          key: position.id,
                                          staticClass: "category",
                                          class: {
                                            open: !position.closed,
                                          },
                                        },
                                        [
                                          _c(
                                            "td",
                                            {
                                              staticClass: "category__header",
                                              attrs: { colspan: "3" },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "category__wrapper",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "category__toggler",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.$set(
                                                            position,
                                                            "closed",
                                                            !position.closed
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("svg-icon", {
                                                        attrs: {
                                                          name: "chevron-top-circled",
                                                          size: 24,
                                                          color: "primary",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "category__name",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            position.name
                                                          ) +
                                                          " "
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "category__count",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              position.items
                                                                .length
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "transition",
                                    {
                                      key: position.id + "-wrapper",
                                      attrs: { name: "slide" },
                                    },
                                    [
                                      !position.closed
                                        ? _c(
                                            "tbody",
                                            {
                                              key: position.id + "-items",
                                              staticClass: "slide-transition",
                                            },
                                            _vm._l(
                                              position.items,
                                              function (item) {
                                                return _c(
                                                  "tr",
                                                  {
                                                    key:
                                                      position.id +
                                                      "-" +
                                                      item.id,
                                                    staticClass: "agreement",
                                                  },
                                                  [
                                                    _c("td", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.company_name
                                                          ) +
                                                          " "
                                                      ),
                                                    ]),
                                                    _c("td", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "agreement__name",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item.agreement_name
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                      item.agreement_contract_type_name
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "agreement__category",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    item.agreement_contract_type_name
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]),
                                                    _c("td", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "agreement-actions",
                                                        },
                                                        [
                                                          _c(
                                                            "button",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "b-popover",
                                                                  rawName:
                                                                    "v-b-popover.html",
                                                                  value: {
                                                                    container:
                                                                      "#app",
                                                                    trigger:
                                                                      "hover blur",
                                                                    content:
                                                                      "Распечатать договор",
                                                                    placement:
                                                                      "top",
                                                                  },
                                                                  expression:
                                                                    "{\n                          container: '#app',\n                          trigger: 'hover blur',\n                          content: 'Распечатать договор',\n                          placement: 'top',\n                        }",
                                                                  modifiers: {
                                                                    html: true,
                                                                  },
                                                                },
                                                              ],
                                                              staticClass:
                                                                "agreement-action",
                                                              attrs: {
                                                                type: "button",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.print(
                                                                      item
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("svg-icon", {
                                                                attrs: {
                                                                  name: "print",
                                                                  size: 16,
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "button",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "b-popover",
                                                                  rawName:
                                                                    "v-b-popover.html",
                                                                  value: {
                                                                    container:
                                                                      "#app",
                                                                    trigger:
                                                                      "hover blur",
                                                                    content:
                                                                      "Скачать в формате PDF",
                                                                    placement:
                                                                      "top",
                                                                  },
                                                                  expression:
                                                                    "{\n                          container: '#app',\n                          trigger: 'hover blur',\n                          content: 'Скачать в формате PDF',\n                          placement: 'top',\n                        }",
                                                                  modifiers: {
                                                                    html: true,
                                                                  },
                                                                },
                                                              ],
                                                              staticClass:
                                                                "agreement-action",
                                                              attrs: {
                                                                type: "button",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.toPdf(
                                                                      item
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("svg-icon", {
                                                                attrs: {
                                                                  name: "pdf",
                                                                  size: 16,
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "button",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "b-popover",
                                                                  rawName:
                                                                    "v-b-popover.html",
                                                                  value: {
                                                                    container:
                                                                      "#app",
                                                                    trigger:
                                                                      "hover blur",
                                                                    content:
                                                                      "Скачать в формате Microsoft Word",
                                                                    placement:
                                                                      "top",
                                                                  },
                                                                  expression:
                                                                    "{\n                          container: '#app',\n                          trigger: 'hover blur',\n                          content: 'Скачать в формате Microsoft Word',\n                          placement: 'top',\n                        }",
                                                                  modifiers: {
                                                                    html: true,
                                                                  },
                                                                },
                                                              ],
                                                              staticClass:
                                                                "agreement-action",
                                                              attrs: {
                                                                type: "button",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.toDoc(
                                                                      item
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("svg-icon", {
                                                                attrs: {
                                                                  name: "word",
                                                                  size: 16,
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              }),
                            ],
                            2
                          ),
                        ])
                      : _vm._e(),
                    !_vm.loading
                      ? _c("div", { staticClass: "sm" }, [
                          _c("div", { staticClass: "agreements-list" }, [
                            _c(
                              "div",
                              { staticClass: "agreements-list__head" },
                              [_vm._v("Юридическое лицо/Договор")]
                            ),
                            _c(
                              "div",
                              { staticClass: "agreements-list__positions" },
                              _vm._l(_vm.positions, function (position) {
                                return _c(
                                  "div",
                                  {
                                    key: position.id,
                                    staticClass:
                                      "agreements-list__position category",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "category__header" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "category__wrapper" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "category__toggler",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.$set(
                                                      position,
                                                      "closed",
                                                      !position.closed
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("svg-icon", {
                                                  attrs: {
                                                    name: "chevron-top-circled",
                                                    size: 24,
                                                    color: "primary",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "category__name" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(position.name) +
                                                    " "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "category__count",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        position.items.length
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "transition",
                                      {
                                        key: position.id + "-wrapper",
                                        attrs: { name: "slide" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !position.closed,
                                                expression: "!position.closed",
                                              },
                                            ],
                                            staticClass:
                                              "agreements-list__items",
                                          },
                                          _vm._l(
                                            position.items,
                                            function (item) {
                                              return _c(
                                                "div",
                                                {
                                                  key: item.id,
                                                  staticClass:
                                                    "agreements-list__item agreements-list-item",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "agreements-list-item__company",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.company_name
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "agreements-list-item__name",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.agreement_name
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  item.agreement_contract_type_name
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "agreements-list-item__category",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item.agreement_contract_type_name
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "agreements-list-item__actions",
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "b-popover",
                                                              rawName:
                                                                "v-b-popover.html",
                                                              value: {
                                                                container:
                                                                  "#app",
                                                                trigger:
                                                                  "hover blur",
                                                                content:
                                                                  "Распечатать договор",
                                                                placement:
                                                                  "top",
                                                              },
                                                              expression:
                                                                "{\n                          container: '#app',\n                          trigger: 'hover blur',\n                          content: 'Распечатать договор',\n                          placement: 'top',\n                        }",
                                                              modifiers: {
                                                                html: true,
                                                              },
                                                            },
                                                          ],
                                                          staticClass:
                                                            "agreement-action",
                                                          attrs: {
                                                            type: "button",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.print(
                                                                item
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("svg-icon", {
                                                            attrs: {
                                                              name: "print",
                                                              size: 16,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "button",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "b-popover",
                                                              rawName:
                                                                "v-b-popover.html",
                                                              value: {
                                                                container:
                                                                  "#app",
                                                                trigger:
                                                                  "hover blur",
                                                                content:
                                                                  "Скачать в формате PDF",
                                                                placement:
                                                                  "top",
                                                              },
                                                              expression:
                                                                "{\n                          container: '#app',\n                          trigger: 'hover blur',\n                          content: 'Скачать в формате PDF',\n                          placement: 'top',\n                        }",
                                                              modifiers: {
                                                                html: true,
                                                              },
                                                            },
                                                          ],
                                                          staticClass:
                                                            "agreement-action",
                                                          attrs: {
                                                            type: "button",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.toPdf(
                                                                item
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("svg-icon", {
                                                            attrs: {
                                                              name: "pdf",
                                                              size: 16,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "button",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "b-popover",
                                                              rawName:
                                                                "v-b-popover.html",
                                                              value: {
                                                                container:
                                                                  "#app",
                                                                trigger:
                                                                  "hover blur",
                                                                content:
                                                                  "Скачать в формате Microsoft Word",
                                                                placement:
                                                                  "top",
                                                              },
                                                              expression:
                                                                "{\n                          container: '#app',\n                          trigger: 'hover blur',\n                          content: 'Скачать в формате Microsoft Word',\n                          placement: 'top',\n                        }",
                                                              modifiers: {
                                                                html: true,
                                                              },
                                                            },
                                                          ],
                                                          staticClass:
                                                            "agreement-action",
                                                          attrs: {
                                                            type: "button",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.toDoc(
                                                                item
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("svg-icon", {
                                                            attrs: {
                                                              name: "word",
                                                              size: 16,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    !_vm.loading && !_vm.positions.length
                      ? _c(
                          "div",
                          { staticClass: "employee-agreements__no-results" },
                          [_vm._v("Записи не найдены")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
          ],
      _c("top-button", { attrs: { root: ".layout" } }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }